import axios from 'axios';
import { SurveyGroup } from './SurveyUtils';
import { OversightOrganization } from './OversightUtils';
import { LanguageObject } from '@/i18n';
import { ColorRGB } from './ChartUtils';

interface DashboardCanvas {
  left: DashboardTile[];
  right: DashboardTile[];
}

type DashboardTileType =
  | 'likert_score'
  | 'submission_status'
  | 'multiple_choice_frequency';

interface DashboardTile<Options = any> {
  uuid: string;
  type: DashboardTileType;
  options: Options;
}

interface TileSubmissionStatusOptions {
  title: LanguageObject;
}

const oversight = async (params?: { id?: number; group: number }) => {
  const resp = await axios.get<{
    group?: number;
    status?: { [key: string]: number };
  }>('/dashboard/oversight/get.php', {
    params: params,
  });
  return resp.data;
};

interface TileLikertScoreOptions {
  title: LanguageObject;
  // questionlabel?: LanguageObject;
  scorelabel?: LanguageObject;
  denominator: 'answercount' | 'netcount';
  questionkeys: {
    key: string;
    label: LanguageObject;
  }[];
  scorekeys: {
    score: number;
    label: LanguageObject;
  }[];
  gradients: {
    start: ColorRGB;
    middle: ColorRGB;
    end: ColorRGB;
  };
}

const getLikertScore = async (params?: {
  surveygroup?: Partial<SurveyGroup>;
  questionkeys?: string[];
  oversight?: Partial<OversightOrganization>;
}) => {
  const resp = await axios.post<
    {
      questionkey: string;
      netcount: number;
      answercount: number;
      score: number;
    }[]
  >('/dashboard/oversight/getLikertScore.php', params);
  return resp.data;
};

interface TileMultipleChoiceFrequencyOptions {
  title: LanguageObject;
  xaxes?: LanguageObject;
  yaxes?: LanguageObject;

  style?: 'aggregate' | 'stack' | 'group';

  questionkeys: {
    key: string;
    label: LanguageObject;
    color?: ColorRGB;
  }[];

  answers: {
    keys: string[];
    label: LanguageObject;
    color?: ColorRGB;
  }[];
}
const getMultipleChoiceFrequency = async (params?: {
  surveygroup?: Partial<SurveyGroup>;
  questionkeys?: string[];
  oversight?: Partial<OversightOrganization>;
}) => {
  const resp = await axios.post<
    {
      questionkey: string;
      frequency?: {
        choicekey: string;
        frequency: number;
      }[];
    }[]
  >('/dashboard/oversight/getMultipleChoiceFrequency.php', params);
  return resp.data;
};

const serviceProvider = async (params?: { id?: number }) => {
  const resp = await axios.get('/dashboard/serviceProvider/get.php', {
    params: params,
  });
  return resp.data;
};

const getParticipations = async (
  group: SurveyGroup,
  isServiceProvider: boolean = false
) => {
  const resp = await axios.get<any>(
    `/dashboard/${
      isServiceProvider ? 'serviceProvider' : 'oversight'
    }/getParticipations.php`,
    { params: { surveygroupid: group.id } }
  );
  return resp.data;
};

const getCurrentSurvey = async (params?: { serviceproviderid?: number }) => {
  const resp = await axios.get('/dashboard/getCurrentSurvey.php', {
    params: params,
  });
  return resp.data;
};

export default {
  oversight,
  getLikertScore,
  getMultipleChoiceFrequency,
  serviceProvider,
  getParticipations,
  getCurrentSurvey,
};

export {
  DashboardCanvas,
  DashboardTile,
  DashboardTileType,
  TileSubmissionStatusOptions,
  TileMultipleChoiceFrequencyOptions,
  TileLikertScoreOptions,
};
